let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("MdYDm")).then(() => parcelRequire('dkMBa'));